module.exports = __webpack_public_path__ + "static/img/3.36904be.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/6/1/zh/3.png
// module id = iCJj
// module chunks = 0